/**
 * メール取り込み（#2965）の許可送信元（allowlist）バリデーション・整形の共通ユーティリティ。
 * 発行フォーム・許可送信元編集ダイアログで共用する。
 */

// 許可送信元: メールアドレス または ドメイン（ひらがな等の無効値を弾く）
const EMAIL_PATTERN = /^[^\s@]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
const DOMAIN_PATTERN = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

/** メールアドレス or ドメインとして妥当か */
export const isValidSender = (value: string): boolean =>
  EMAIL_PATTERN.test(value) || DOMAIN_PATTERN.test(value);

/** 改行・カンマ区切りのテキストを、トリム済みの送信元配列に変換する */
export const parseSenders = (text: string): string[] =>
  text
    .split(/[\n,]/)
    .map(s => s.trim())
    .filter(s => s !== '');
